import { render, staticRenderFns } from "./ItemAppCard.vue?vue&type=template&id=cdb70ba0"
import script from "./ItemAppCard.vue?vue&type=script&lang=js"
export * from "./ItemAppCard.vue?vue&type=script&lang=js"
import style0 from "./ItemAppCard.vue?vue&type=style&index=0&id=cdb70ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports